/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreAtlasClusterInput {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  /**
  * The ID of the Atlas project to restore the cluster to
  */
  'atlasProjectId': string;
  /**
  * New name of the restored cluster
  */
  'clusterName': string;
  /**
  * Optional tags to apply to the restored cluster
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "atlasProjectId",
      "baseName": "atlasProjectId",
      "type": "string",
      "format": ""
    },
    {
      "name": "clusterName",
      "baseName": "clusterName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAtlasClusterInput.attributeTypeMap;
  }

  public constructor() {
  }
}

